import { tv } from "../../variants/tv.js";
const merchDisplayPillVariants = tv({
    slots: {
        root: 'relative isolate inline-flex items-center gap-[0.5em] px-[0.75em]',
        brand: 'inline-flex font-medium',
        discount: 'whitespace-nowrap'
    },
    variants: {
        theme: {
            neutral: {},
            brand: {},
            highlight: {},
            benefit: {},
            vipMember: {},
            vipBlue: {},
            vipGold: {},
            vipPlatinum: {}
        },
        emphasis: {
            bold: {},
            medium: {}
        },
        textSize: {
            heading6: {
                root: 'py-1 text-heading6'
            },
            heading5: {
                root: 'py-1 text-heading5'
            },
            heading4: {
                root: 'py-1 text-heading4'
            },
            heading3: {
                root: 'py-1 text-heading3'
            },
            heading2: {
                root: 'py-1 text-heading2'
            },
            heading1: {
                root: 'py-1 text-heading1'
            },
            body3: {
                root: 'py-0.5 text-body3'
            },
            body2: {
                root: 'py-0.5 text-body2'
            },
            body1: {
                root: 'py-0.5 text-body1'
            }
        },
        alignment: {
            left: {
                root: 'rounded-r-full pl-0 before:absolute before:top-0 before:right-[calc(100%-1px)] before:bottom-0 before:w-[calc(var(--merch-pill-bleed)+1px)] before:bg-inherit'
            },
            right: {
                root: 'rounded-l-full pr-0 before:absolute before:top-0 before:bottom-0 before:left-[calc(100%-1px)] before:w-[calc(var(--merch-pill-bleed)+1px)] before:bg-inherit'
            },
            centered: {
                root: 'rounded-full'
            }
        }
    },
    compoundVariants: [
        {
            theme: 'neutral',
            emphasis: 'medium',
            class: {
                root: 'bg-neutral-3 text-neutral-11'
            }
        },
        {
            theme: 'brand',
            emphasis: 'medium',
            class: {
                root: 'bg-marketingBrand-3 text-marketingBrand-11'
            }
        },
        {
            theme: 'highlight',
            emphasis: 'medium',
            class: {
                root: 'bg-highlight-3 text-highlight-11'
            }
        },
        {
            theme: 'benefit',
            emphasis: 'medium',
            class: {
                root: 'bg-benefit-3 text-benefit-11'
            }
        },
        {
            theme: 'vipMember',
            emphasis: 'medium',
            class: {
                root: 'bg-vipMember-3 text-vipMember-11'
            }
        },
        {
            theme: 'vipBlue',
            emphasis: 'medium',
            class: {
                root: 'bg-vipBlue-3 text-vipBlue-11'
            }
        },
        {
            theme: 'vipGold',
            emphasis: 'medium',
            class: {
                root: 'bg-vipGold-3 text-vipGold-11'
            }
        },
        {
            theme: 'vipPlatinum',
            emphasis: 'medium',
            class: {
                root: 'bg-vipPlatinum-3 text-vipPlatinum-11'
            }
        },
        {
            theme: 'neutral',
            emphasis: 'bold',
            class: {
                root: 'bg-neutral-8 text-neutral-1'
            }
        },
        {
            theme: 'brand',
            emphasis: 'bold',
            class: {
                root: 'bg-marketingBrand-8 text-marketingBrand-1'
            }
        },
        {
            theme: 'highlight',
            emphasis: 'bold',
            class: {
                root: 'bg-highlight-8 text-highlight-1'
            }
        },
        {
            theme: 'benefit',
            emphasis: 'bold',
            class: {
                root: 'bg-benefit-8 text-benefit-1'
            }
        },
        {
            theme: 'vipMember',
            emphasis: 'bold',
            class: {
                root: 'bg-vipMember-8 text-vipMember-1'
            }
        },
        {
            theme: 'vipBlue',
            emphasis: 'bold',
            class: {
                root: 'bg-vipBlue-8 text-vipBlue-1'
            }
        },
        {
            theme: 'vipGold',
            emphasis: 'bold',
            class: {
                root: 'bg-vipGold-8 text-vipGold-1'
            }
        },
        {
            theme: 'vipPlatinum',
            emphasis: 'bold',
            class: {
                root: 'bg-vipPlatinum-8 text-vipPlatinum-1'
            }
        }
    ],
    defaultVariants: {
        theme: 'neutral',
        emphasis: 'bold',
        alignment: 'left',
        textSize: 'heading6'
    }
});
const merchDisplayPillThemes = Object.keys(merchDisplayPillVariants.variants.theme);
const merchDisplayPillEmphases = Object.keys(merchDisplayPillVariants.variants.emphasis);
const merchDisplayPillAlignments = Object.keys(merchDisplayPillVariants.variants.alignment);
const merchDisplayPillTextSizes = Object.keys(merchDisplayPillVariants.variants.textSize);
export { merchDisplayPillAlignments, merchDisplayPillEmphases, merchDisplayPillTextSizes, merchDisplayPillThemes, merchDisplayPillVariants };
